// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__12THD","fileInput":"Form_fileInput__2UlHE","buttons":"Form_buttons__3X3hn","buttonSubmit":"Form_buttonSubmit__3yRlK","buttonClear":"Form_buttonClear__2Eguo"};